var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "#E7EDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    clipPath: "url(#clip0_1_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 10.6042V13.3992H6V10.6042C6 9.07202 7.25357 7.81845 8.78571 7.81845H12.0357V10.567C12.0357 11.0777 12.4536 11.4956 12.9643 11.4956C13.475 11.4956 13.8929 11.0777 13.8929 10.567V7.81845H24.1071V10.567C24.1071 11.0777 24.525 11.4956 25.0357 11.4956C25.5464 11.4956 25.9643 11.0777 25.9643 10.567V7.81845H29.2143C30.7464 7.81845 32 9.07202 32 10.6042ZM24.5714 24.5513H31.4336L23.6429 31.497V25.4799C23.6429 24.9692 24.0607 24.5513 24.5714 24.5513Z",
    fill: "#7290EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.2579V22.6957H24.5714C23.0393 22.6957 21.7857 23.9493 21.7857 25.4814V32H8.78571C7.25357 32 6 30.7464 6 29.2143V15.2579H32ZM13.8929 6.92857V7.82H12.0357V6.92857C12.0357 6.41786 12.4536 6 12.9643 6C13.475 6 13.8929 6.41786 13.8929 6.92857ZM25.9643 6.92857V7.82H24.1071V6.92857C24.1071 6.41786 24.525 6 25.0357 6C25.5464 6 25.9643 6.41786 25.9643 6.92857Z",
    fill: "#7290EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3486 25.8721L13.7646 19.8906H14.5557L14.7363 20.8867L13.2275 27H12.3779L12.3486 25.8721ZM11.6211 19.8906L12.793 25.8721L12.6953 27H11.748L10.1709 19.8906H11.6211ZM15.9814 25.8477L17.1387 19.8906H18.5889L17.0166 27H16.0693L15.9814 25.8477ZM15 19.8906L16.4258 25.8965L16.3867 27H15.5371L14.0186 20.8818L14.2139 19.8906H15Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/c3.3f5a33c930a9c56102837be1bd8ba348.svg";
export { ForwardRef as ReactComponent };